import ViewAssignmentPage from './ViewAssignmentPage'
export default ViewAssignmentPage;